// src/services/applicationService.js
import {
  collection, doc, addDoc, updateDoc, getDocs,
  query, where, serverTimestamp, increment,
} from 'firebase/firestore';
import { db } from '../config/firebase';

// ── Submit application ────────────────────────────────────────────────
export async function submitApplication(user, profile, job) {
  // Guard: no duplicate applications
  const existing = await getDocs(
    query(
      collection(db, 'applications'),
      where('userId',        '==', user.uid),
      where('opportunityId', '==', job.id),
    )
  );
  if (!existing.empty) throw new Error('already_applied');

  const appRef = await addDoc(collection(db, 'applications'), {
    // Applicant info
    userId:       user.uid,
    userEmail:    user.email,
    userName:     profile?.displayName || profile?.fullName || user.email,
    userPhone:    profile?.phone     || '',
    kycStatus:    profile?.kycStatus || 'pending',
    cvUrl:        profile?.cvUrl     || '',
    skills:       profile?.skills    || [],
    bio:          profile?.bio       || '',

    // Job info
    opportunityId:    job.id,
    opportunityTitle: job.title,
    company:          job.company || job.collaboratorName || '',
    location:         job.location || '',
    payDisplay:       job.payDisplay || '',

    // Routing
    collaboratorId: job.collaboratorId,

    // Status lifecycle: new → shortlisted → rejected → hired
    status:    'new',
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });

  // Increment the applicant counter on the job doc
  await updateDoc(doc(db, 'opportunities', job.id), {
    applicants: increment(1),
  });

  // Notify the collaborator
  await addDoc(collection(db, 'notifications'), {
    userId:           job.collaboratorId,
    type:             'new_application',
    opportunityId:    job.id,
    opportunityTitle: job.title,
    applicationId:    appRef.id,
    applicantName:    profile?.displayName || user.email,
    message:          `👤 New application for "${job.title}" from ${profile?.displayName || user.email}`,
    read:             false,
    createdAt:        serverTimestamp(),
  });

  return appRef.id;
}

// ── Update application status (collaborator action) ───────────────────
export async function updateApplicationStatus(applicationId, status) {
  await updateDoc(doc(db, 'applications', applicationId), {
    status,
    updatedAt: serverTimestamp(),
  });
}
